import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { FooterMenuComponent } from './footer-menu.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule
  ],
  declarations: [FooterMenuComponent],
  exports: [FooterMenuComponent]
})
export class FooterMenuModule { }
